import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {defineComponent} from 'vue';
import {NDialogProvider, NLoadingBarProvider, NMessageProvider,} from 'naive-ui';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppProvider',
  setup(__props) {

defineComponent({
    name: 'AppProvider',
    components: {
        NMessageProvider,
        NLoadingBarProvider,
        NDialogProvider,
    },
    
});


return (_ctx: any,_cache: any) => {
  const _component_n_notification_provider = _resolveComponent("n-notification-provider")!

  return (_openBlock(), _createBlock(_unref(NLoadingBarProvider), null, {
    default: _withCtx(() => [
      _createVNode(_component_n_notification_provider, null, {
        default: _withCtx(() => [
          _createVNode(_unref(NMessageProvider), null, {
            default: _withCtx(() => [
              _createVNode(_unref(NDialogProvider), null, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "default")
                ]),
                _: 3
              })
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})